import { SelectionModel } from "@angular/cdk/collections";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from "@angular/material/tree";

import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { MaterialModule } from "../../../core/shared/material.module";
export interface TreeNode {
  item: string;
  children?: TreeNode[];
}

interface FlatNode {
  item: string;
  level: number;
  expandable: boolean;
}
@Component({
  selector: "app-checklist-tree-modal",
  standalone: true,
  imports: [MaterialModule, MatTreeModule],
  templateUrl: "./checklist-tree-modal.component.html",
  styleUrl: "./checklist-tree-modal.component.scss",
})
export class ChecklistTreeModalComponent {
  @Input() configs: any = {
    title: "Select Test Type (for Generated Test Cases)",
    rawData: {
      Functional: ["Smoke", "Sanity", "Regression"],
      "Non functional": {},
    },
    saveBtnText: "Select & Generate",
  };
  activeModal = inject(NgbActiveModal);

  treeControl = new FlatTreeControl<FlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener<TreeNode, FlatNode>(
    (node, level) => ({
      item: node.item,
      level,
      expandable: !!node.children?.length,
    }),
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  checklistSelection = new SelectionModel<FlatNode>(true);

  constructor() {
    this.dataSource.data = this.convertToTree(this.configs?.rawData);
  }

  convertToTree(obj: any): TreeNode[] {
    return Object.keys(obj).map((key) => {
      const val = obj[key];
      return {
        item: key,
        children: Array.isArray(val)
          ? val.map((v: string) => ({ item: v }))
          : val
          ? this.convertToTree(val)
          : [],
      };
    });
  }
  hasChild = (_: number, node: FlatNode) => node.expandable;

  toggleSelection(node: FlatNode): void {
    if (node.expandable) {
      // Parent nodes are not selectable
      return;
    }

    // Deselect all previously selected nodes
    this.checklistSelection.clear();

    // Select only the clicked leaf node
    this.checklistSelection.select(node);
  }

  allDescendantsSelected(node: FlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
  }

  someDescendantsSelected(node: FlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return (
      descendants.some((child) => this.checklistSelection.isSelected(child)) &&
      !this.allDescendantsSelected(node)
    );
  }

  submit() {
    let selections = this.checklistSelection.selected
      .filter((node) => !node.expandable)
      .map((node) => node.item);

    this.activeModal.close({
      value: selections,
    });
  }
}
